import clsx from 'clsx';

import * as styles from './SuggestionGroupLabel.sty.js';
import { useBehavioralTrackingProps } from '../../../core/hooks/useBehavioralTrackingProps.js';
import type { BehaviorTrackingProps } from '../../../core/types/behavior-tracking-props.js';
import { DataTestId } from '../../../core/types/data-props.js';
import { DOMProps } from '../../../core/types/dom.js';
import { StylingProps } from '../../../core/types/styling-props.js';
import { WithChildren } from '../../../core/types/with-children.js';
import { textStyle as textStyleCSS } from '../../../styles/textStyle.sty.js';

/**
 * Accepted properties for the FilterField suggestion group label.
 * @public
 */
export type FilterFieldSuggestionGroupLabelProps = WithChildren &
  DOMProps &
  StylingProps &
  DataTestId &
  BehaviorTrackingProps;

/**
 * @public
 */
export const SuggestionGroupLabel = (
  props: FilterFieldSuggestionGroupLabelProps,
) => {
  const {
    children,
    id,
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
    ...remainingProps
  } = props;

  const [behavioralTrackingProps] = useBehavioralTrackingProps(remainingProps);

  return (
    <div
      role="presentation"
      id={id}
      data-testid={dataTestId}
      style={consumerStyle}
      {...behavioralTrackingProps}
      className={clsx(
        styles.suggestionGroupLabel,
        consumerClassName,
        textStyleCSS({ textStyle: 'small-emphasized' }),
      )}
    >
      {children}
    </div>
  );
};

SuggestionGroupLabel.displayValue = 'FilterField.SuggestionGroupLabel';
